import { __assign } from "tslib";
import React from 'react';
import ImageMonoHtmlView from './ImageHtml';
import ImageMonoReactView from './Image';
var ImageMonoView = function (props) {
    if (props.isHtml) {
        return React.createElement(ImageMonoHtmlView, __assign({}, props));
    }
    return React.createElement(ImageMonoReactView, __assign({}, props));
};
ImageMonoView.displayName = 'ImageMonoView';
export default ImageMonoView;
//# sourceMappingURL=index.js.map